'use strict';

module.exports = {
    template: require('html-loader!./performanceCard.html'),
    controller: function () {
        var $ctrl = this;

        $ctrl.hasLongTitle = $ctrl.performance.title.length > 30;

        return $ctrl;
    },
    bindings: {
        performance: '<'
    }
};



// WEBPACK FOOTER //
// ./widgets/components/performanceCard.js